import { Icon, Button, Card, CardBody } from '@repo/ui';

interface ErrorCardProps {
  title: string;
  message: string;
  onRetry?: () => void;
  statusCode?: number;
}

export function ErrorCard({
  title,
  message,
  onRetry,
  statusCode,
}: ErrorCardProps) {
  const isPermissionError = statusCode === 401 || statusCode === 403;

  const displayTitle = isPermissionError
    ? 'Access Restricted'
    : title;

  const displayMessage = isPermissionError
    ? `You don’t have permission to access this information.
This section is restricted based on your role.

Please contact your administrator if you believe this is a mistake.`
    : message;

  return (
    <Card variant="outlined" padding="lg">
      <CardBody>
        <div className="text-center py-8">
          <div className="flex justify-center mb-3">
            <Icon
              name={isPermissionError ? 'HiLockClosed' : 'HiExclamationCircle'}
              size="xl"
              className={isPermissionError ? 'text-yellow-500' : 'text-red-600'}
            />
          </div>

          <h3 className="text-lg font-medium mb-2">
            {displayTitle}
          </h3>

          <p className="text-xtnd-dark-600 dark:text-xtnd-dark-400 mb-4 whitespace-pre-line">
            {displayMessage}
          </p>

          {/* Retry only makes sense for non-permission errors */}
          {!isPermissionError && onRetry && (
            <Button
              variant="primary"
              onClick={onRetry}
              leftIcon={<Icon name="HiRefresh" size="sm" />}
            >
              Retry
            </Button>
          )}
        </div>
      </CardBody>
    </Card>
  );
}
